import React, { memo, useMemo } from 'react';
import { FunctionField, TextField } from 'react-admin';
import { Box, TableCell, TableRow, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import DrawerSimpleShowLayout from '../../../../base/components/ra/drawers/DrawerSimpleShowLayout';
import { AmountField } from '../../../../base/components/ra/fields';
import ArrayWithPaginationField from '../../../../base/components/ra/fields/arrayWithPagination.field';
import { formatMoney } from '../../../../services/util/formatNumber';

const ChargeDetailsTable = memo(
  ({ record, fieldKey, title }) =>
    record?.[fieldKey] && (
      <Box id={fieldKey}>
        <Box
          component={DrawerSimpleShowLayout}
          sx={{
            flexGrow: 1,
            bgcolor: 'white',
            borderRadius: 12,
            padding: '24px !important',
          }}
          record={record}
        >
          <Box
            component={Typography}
            variant="h4"
            sx={{
              marginBottom: '18px !important',
            }}
          >
            {title}
          </Box>
          <ArrayWithPaginationField
            label={false}
            source={fieldKey}
            expand={<BrandExpand />}
            fieldKey="brandId"
            style={{
              maxHeight: 'unset',
            }}
          >
            <TextField source="brandName" label="resources.invoice.fields.brandCurrency" />
            <TextField source="currencyCode" label="resources.currency.name" />
            <AmountField source="turnover" label="resources.invoice.fields.turnover" />
            <AmountField source="ggr" label="resources.invoice.fields.ggr" />
            <FunctionField label="resources.invoice.fields.royalty" render={() => '-'} />
            <AmountField source="amount" label="resources.invoice.fields.amount" />
          </ArrayWithPaginationField>
        </Box>
      </Box>
    ),
);

export default ChargeDetailsTable;

ChargeDetailsTable.propTypes = {
  fieldKey: PropTypes.string.isRequired,
};

const BrandExpand = ({ record }) => {
  if (!record || !record.details?.length) return null;

  const columns = useMemo(
    () => [
      {
        render: () => null,
      },
      {
        source: 'localCurrencyCode',
      },
      {
        source: 'localCurrencyCode',
      },
      {
        render: (record) => formatMoney(record.turnover),
      },
      {
        render: (record) => formatMoney(record.ggr),
      },
      {
        render: (record) => `${record.royaltyPercent}%`,
      },
      {
        render: (record) => formatMoney(record.amount),
      },
    ],
    [],
  );

  return record.details.map((row) => (
    <TableRow key={row.localCurrencyCode}>
      {columns.map((col, colIndex) => {
        const value = typeof col.render === 'function' ? col.render(row) : row[col.source];

        return <TableCell key={colIndex}>{value}</TableCell>;
      })}
    </TableRow>
  ));
};
